"use client";

import Image from "next/image";

import { coinbtIconColor, runeIconColor } from "~/assets";
import { CopyWrapper } from "~/components/common/CopyWrapper";
import { Popover, PopoverContent, PopoverTrigger, Skeleton } from "~/components/ui";
import { formatPrice } from "~/helpers";
import { api } from "~/services/api";
import { NavbarCart } from "../NavbarCart";
import { NavbarConnectWalletPopover } from "../NavbarConnectWalletPopover";
import { NavbarLogo } from "../NavbarLogo";
import { NavbarDesktopLink } from "./NavbarDesktopLink";
import { NavbarDesktopSearch } from "./NavbarDesktopSearch";
import { TransactionHistory } from "./TransactionHistory";

export function NavbarDesktop() {
  const { data: priceByToken, isLoading: isLoadingRunePrice } = api.price.getByToken.useQuery();

  return (
    <div className="relative z-50 hidden w-full grid-cols-[1fr_minmax(240px,1fr)_1fr] items-center gap-1 md:grid lg:gap-2">
      <div className="flex items-center space-x-4 md:space-x-6 lg:space-x-8">
        <NavbarLogo className="pr-1" />

        <NavbarDesktopLink href="/market">Market</NavbarDesktopLink>

        <NavbarDesktopLink href="/register">Register</NavbarDesktopLink>
      </div>

      <NavbarDesktopSearch />

      <div className="flex items-center space-x-3">
        <div className="ml-auto flex shrink-0 items-center space-x-3">
          <Popover>
            <CopyWrapper
              tooltip={{ content: "Swap $RUNE with THORSwap Widget" }}
              className="translate-x-0 text-[#8C8C8C] hover:text-white/80"
            >
              <PopoverTrigger asChild>
                <div className="flex flex-shrink-0 items-center space-x-1">
                  <Image alt="coinbt price" src={runeIconColor} className="h-5 w-5" />

                  <Skeleton className="h-7 w-12" active={isLoadingRunePrice}>
                    <div>
                      {priceByToken?.RUNE
                        ? formatPrice(priceByToken?.RUNE, {
                            asUSD: true,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "-"}
                    </div>
                  </Skeleton>
                </div>
              </PopoverTrigger>
            </CopyWrapper>

            <PopoverContent className="w-[520px]" sideOffset={26} forceMount>
              <iframe
                src="https://app.thorswap.finance/swap?address=pixel&fee=75&logoUrl=https://forge.coinbot.app/ForgeLogoWord.svg"
                height="600px"
                width="100%"
                title="THORSwap Widget"
              />
            </PopoverContent>
          </Popover>

          <CopyWrapper
            tooltip={{ content: "Swap $COINBT with Uniswap App" }}
            className="!-ml-0.5 !-mr-1.5 translate-x-0 text-[#8C8C8C] hover:text-white/80"
            onClick={() => {
              window?.open(
                "https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=0x6fa5e1c43b5a466cbd1cae7993b67c982400d481",
                "_blank",
                "noopener,noreferrer",
              );
            }}
          >
            <div className="flex flex-shrink-0 items-center space-x-1">
              <Image alt="coinbt price" src={coinbtIconColor} className="h-5 w-5" />

              <Skeleton className="h-7 w-12" active={false}>
                <div>
                  {priceByToken?.COINBT
                    ? formatPrice(priceByToken?.COINBT, {
                        asUSD: true,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "-"}
                </div>
              </Skeleton>
            </div>
          </CopyWrapper>

          <NavbarCart />

          <TransactionHistory />
        </div>

        <NavbarConnectWalletPopover />
      </div>
    </div>
  );
}
